import { render } from "./Companies.vue?vue&type=template&id=6c5bfa7d&scoped=true"
import script from "./Companies.vue?vue&type=script&lang=js"
export * from "./Companies.vue?vue&type=script&lang=js"

import "./Companies.vue?vue&type=style&index=0&id=6c5bfa7d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6c5bfa7d"

export default script